(() => {
  const tunedImages = new WeakSet();
  const watchedTracks = new WeakSet();
  const animationSelector = '.fbgp-track, .fm-ticker-track, .fs__track';

  const imageObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const image = entry.target;
          image.loading = 'eager';
          image.removeAttribute('fetchpriority');
          observer.unobserve(image);
        });
      }, { rootMargin: '1200px 0px' })
    : null;

  const trackObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      }, { rootMargin: '400px 0px' })
    : null;

  const tuneImages = (scope = document) => {
    const root = scope.querySelectorAll ? scope : document;
    root.querySelectorAll('#MainContent img, main img').forEach((image) => {
      if (tunedImages.has(image)) return;
      tunedImages.add(image);
      image.decoding = 'async';

      if (image.loading === 'eager' || image.getAttribute('fetchpriority') === 'high') return;

      const rect = image.getBoundingClientRect();
      if (!image.hasAttribute('loading') && rect.top > window.innerHeight * 1.25) {
        image.loading = 'lazy';
      }

      if (image.loading === 'lazy' && imageObserver) {
        if (rect.top > window.innerHeight * 3) image.setAttribute('fetchpriority', 'low');
        imageObserver.observe(image);
      }
    });

    root.querySelectorAll('#MainContent iframe, main iframe').forEach((frame) => {
      if (!frame.hasAttribute('loading')) frame.loading = 'lazy';
    });
  };

  const observeTracks = (scope = document) => {
    if (!trackObserver) return;
    scope.querySelectorAll?.(animationSelector).forEach((track) => {
      if (watchedTracks.has(track)) return;
      watchedTracks.add(track);
      trackObserver.observe(track);
    });
  };

  const run = (scope = document) => {
    tuneImages(scope);
    observeTracks(scope);
  };

  const start = () => {
    run(document);
    if ('MutationObserver' in window) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) run(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target || document));
})();